export const STICKY_FILTER_MENU_VISIBILITY_NAME = 'stickyFilterMenu';

export interface StickyMenuImpression {
  event: 'custom_event';
  event_action: 'filter & sort sticky impression';
  event_category: 'Filter & sort';
  event_label: 'icon';
}
